import { APP_REDIRECTION_SCREENS } from '@/utils/enums'
import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'
import {
  ENGLISH_COHORT_ID,
  MATHS_COHORT_ID,
  SCHOOL_CURRICULUM_COHORT_ID,
} from '@/constants/common'


const ICJRLandingHeroSection: {
  [key: string]: IFormFieldType
} = {
  isOtplessEnabled: {
    type: 'Boolean',
    label: 'Enable Otpless',
    required: false,
  },
  shouldTriggerTruecaller: {
    type: 'Boolean',
    label: 'Should Trigger Truecaller',
    required: false,
  },
  heroSection: {
    type: 'Object',
    label: 'Hero Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      classSubHeading: {
        type: 'String',
        label: 'Class Sub Heading',
        required: false,
      },
      learningProgramButtonText: {
        type: 'String',
        label: 'Button Text',
        required: false,
      },
      bannerImage: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Banner Image',
        required: false,
      },
      backgroundImage: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Background Image',
        required: false,
      },
    },
  },
  goalSection: {
    type: 'Object',
    label: 'Goal Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      backgroundImage: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Background Image',
        required: false,
      },
      goals: {
        type: 'List',
        label: 'Goals',
        required: false,
        children: {
          cohortId: {
            type: 'String',
            label: 'Cohort ID',
            required: false,
          },
          title: {
            type: 'String',
            label: 'Title',
            required: false,
          },
          description: {
            type: 'String',
            label: 'Description',
            required: false,
          },
          metaDescription: {
            type: 'List',
            label: 'Meta Description',
            required: false,
            children: {
              title: {
                type: 'String',
                label: 'Title',
                required: false,
              },
              icon: {
                type: 'Media',
                mediaTypes: [MediaType.IMAGE],
                label: 'Icon',
                required: false,
              },
            },
          },
          chooseClassTitle: {
            type: 'String',
            label: 'Choose Class Title',
            required: false,
          },
          color: {
            type: 'String',
            label: 'Color',
            required: false,
          },
          goalBatches: {
            type: 'List',
            label: 'Batch Class Details',
            required: false,
            children: {
              batchId: {
                type: 'String',
                label: 'Batch ID',
                required: false,
              },
              classText: {
                type: 'Number',
                label: 'Class',
                required: false,
              },
            },
          },
          thumbnail: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Thumbnail',
            required: false,
          },
          webBanner: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Web Banner',
            required: false,
          },
          mWebBanner: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Mobile Web Banner',
            required: false,
          },
          showVideoBanner: {
            type: 'Boolean',
            label: 'Show Video Banner',
            required: false,
          },
          videoBannerUrl: {
            type: 'Media',
            mediaTypes: [MediaType.VIDEO],
            label: 'Video Banner URL',
            required: false,
            dependencies: [
              {
                field: 'showVideoBanner',
                value: true,
                rules: {
                  required: true,
                  visible: true,
                },
              },
              {
                field: 'showVideoBanner',
                value: false,
                rules: {
                  visible: false,
                },
              },
            ],
          },
          mwebvideoBannerUrl: {
            type: 'Media',
            mediaTypes: [MediaType.VIDEO],
            label: 'Mweb Video Banner URL',
            required: false,
            dependencies: [
              {
                field: 'showVideoBanner',
                value: true,
                rules: {
                  required: true,
                  visible: true,
                },
              },
              {
                field: 'showVideoBanner',
                value: false,
                rules: {
                  visible: false,
                },
              },
            ],
          },
          successRedirectClient: {
            type: 'Radio',
            label: 'Success Redirect Client',
            required: false,
            options: [
              {
                key: 'WEB',
                value: 'WEB',
              },
              {
                key: 'APP',
                value: 'APP',
              },
            ],
          },
        },
      },
    },
  },
  appRedirectionScreen: {
    type: 'Select',
    label: 'Redirection Screen on App',
    multiple: false,
    options: [
      {
        key: 'payment',
        value: 'Payment',
      },
      {
        key: 'order_summary',
        value: 'Order Summary',
      },
    ],
  },
}

export default ICJRLandingHeroSection

export type CJRLandingHeroSectionProps = {
  heroSection: HeroSectionProps
  isOtplessEnabled: boolean
  appRedirectionScreen: APP_REDIRECTION_SCREENS
  shouldTriggerTruecaller?: boolean
  goalSection: GoalSectionProps
}

export type HeroSectionProps = {
  heading: string
  subHeading: string
  classSubHeading: string
  learningProgramButtonText: string
  bannerImage: string
  backgroundImage: string
}

export type GoalBatchProps = {
  batchId: string
  classText: number
}

export type MetaDescriptionProps = {
  title: string
  icon: string
}

export type GoalProps = {
  cohortId: string
  title: string
  description: string
  color: string
  metaDescription?: MetaDescriptionProps[]
  chooseClassTitle?: string
  goalBatches: GoalBatchProps[]
  thumbnail: string
  webBanner: string
  mWebBanner: string
  videoBannerUrl?: string
  mwebvideoBannerUrl?: string
  showVideoBanner?: boolean
  successRedirectClient: 'WEB' | 'APP'
}

export type GoalSectionProps = {
  heading: string
  subHeading: string
  backgroundImage: string
  goals: GoalProps[]
}

export const HeroSectionDefaultValues: CJRLandingHeroSectionProps = {
  isOtplessEnabled: false,
  shouldTriggerTruecaller: false,
  appRedirectionScreen: APP_REDIRECTION_SCREENS.PAYMENT,
  heroSection: {
    heading: 'Learning made fun for Curious Minds!',
    subHeading: 'Let your child start learning how to excel in School Curriculum, Maths & English!',
    classSubHeading: 'For classes 1st to 8th',
    learningProgramButtonText: 'View Learning Programs',
    bannerImage:
      'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/f0d0a00a-0527-4d57-8be1-9cd8fc827212.webp',
    backgroundImage: 'https://static.pw.live/production-curiousjr-fundoo/static/images/hero-bg.svg',
  },
  goalSection: {
    heading: 'Pick a learning program & get started!',
    subHeading: 'Choose from our Best Courses for your kid ⭐',
    backgroundImage: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-selection-bg.svg',
    goals: [
      {
        cohortId: SCHOOL_CURRICULUM_COHORT_ID,
        title: 'School Tuition',
        description: "Fuel your child's Academic growth! See their confidence and grades improve.",
        color: '#FFFAF5',
        metaDescription: [
          {
            title: 'Classes: 3rd to 9th',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/class.svg',
          },
          {
            title: 'Duration: 6 Days',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/duration.svg',
          },
          {
            title: 'English, Maths, Science, Social Studies',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/subject.svg',
          },
          {
            title: 'Aligned as per CBSE, ICSE, State Boards',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/board.svg',
          },
        ],
        chooseClassTitle: 'Choose Class to Enroll',
        goalBatches: [],
        thumbnail:
          'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/school-curriculum.jpeg',
        webBanner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/b3fb6572-7616-4da1-ae57-6e2025a6bc67.webp',
        mWebBanner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/c0d9a894-fa80-4ad6-b894-9ea0709333e8.webp',
        videoBannerUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4',
        mwebvideoBannerUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4',

        showVideoBanner: false,
        successRedirectClient: 'WEB',
      },
      {
        cohortId: ENGLISH_COHORT_ID,
        title: 'Learn English',
        description: 'Help your child master English skills. Get ready to be Cambridge certified!',
        color: '#F6FEF9',
        metaDescription: [
          {
            title: 'Classes: 1st to 8th',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/class.svg',
          },
          {
            title: 'Duration: 1 Day',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/duration.svg',
          },
          {
            title: '4-5 Learners per class',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/learner-class.svg',
          },
          {
            title: 'Aligned with the Cambridge English Scale and CEFR ',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/board.svg',
          },
        ],
        chooseClassTitle: 'Choose Class to Enroll',
        goalBatches: [],
        thumbnail:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/57173c21-acfb-4cd9-8f7f-c4f1d2ccff1f.webp',
        webBanner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/bd8c4f5c-1143-4774-bd76-4417225fb9f6.webp',
        mWebBanner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/a96f6ff4-d8d4-4d68-97c2-8ac3c3ab58c2.webp',
        videoBannerUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4',
        mwebvideoBannerUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4',

        showVideoBanner: false,
        successRedirectClient: 'WEB',
      },
      {
        cohortId: MATHS_COHORT_ID,
        title: 'Maths Learning',
        description:
          'Unlock your child’s Math super powers! Solve complex Math calculations in just seconds.',
        color: '#F5FAFF',
        metaDescription: [
          {
            title: 'Classes: 1st to 8th',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/class.svg',
          },
          {
            title: 'Duration: 6 Days',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/duration.svg',
          },
          {
            title: '10-15 Learners per Class',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/learner-class.svg',
          },
          {
            title: 'Math-based curriculum for enhanced mental abilities',
            icon: 'https://static.pw.live/production-curiousjr-fundoo/static/images/goal-select/goal-card/curriculum.svg',
          },
        ],
        chooseClassTitle: 'Choose Class to Enroll',
        goalBatches: [],
        thumbnail:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/6684e9f7-75b0-4498-8149-7e3635a5f8c6.webp',
        webBanner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/cd7ecd61-34e4-43a3-bffd-a61437b929fc.webp',
        mWebBanner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/6e61c78a-abc5-4428-8d10-05f394e84954.webp',
        videoBannerUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4',
        mwebvideoBannerUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/66a8bd22-0124-46cf-a815-74e7c777bbe0.mp4',
        showVideoBanner: false,
        successRedirectClient: 'WEB',
      },
    ],
  },
}
